import BaseModel from '../core/BaseModel'
import ServiceUnitModel from './ServiceUnitModel'
//import CategoriesModel from "./CategoriesModel";
import {constants} from '../services/constants'
export default class ServiceSuppliesModel extends BaseModel {
    constructor() {
        super({
                name: "service_supplies",
                tableName: 'core_service_supplies',
                display_key: 'name'
            },
            {
                id: {
                    name: 'id',
                    type: "String",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                code: {
                    name: 'code',
                    type: "String",
                    label: 'Mã vật tư - dịch vụ',
                    filter: { type: 'input', match: 'custom', placeHolder: 'Nhập mã vật tư - dịch vụ'}
                },
                name: {
                    name: 'name',
                    type: "String",
                    label: 'Tên vật tư - dịch vụ',
                    filter: { type: 'input', match: 'custom', placeHolder: 'Nhập tên vật tư - dịch vụ'}
                },
                unit: {
                    name: 'unit',
                    type: "Selection",
                    label: 'Đơn vị tính',
                    class: 'center',
                    dataType: 'Label',
                    width: 12,
                    sortable: true,
                    params: {select: 'code, name', variables: {status: {'_in': [1]}}},
                    models: new ServiceUnitModel(),
                    filter: { type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals'}
                },
                unit_price_tmp: {
                    name: "unit_price_tmp",
                    label: "Đơn giá",
                    class: 'center right_td_unit_price',
                    type: "Computed",
                    width: 12,
                    filter: {type: 'input', match: 'contains'},
                    computed: (data) => {
                        data.unit_price_tmp = (!constants.isEmpty(data.unit_price)) ? constants.numberFormat(data.unit_price, 0, '', '.'):'0';
                    },
                    // display: { list: true, add: false, edit: false }
                },
                unit_price: {
                    name: 'unit_price',
                    type: "Number",
                    label: 'Đơn giá',
                    filter: {type: 'input', match: 'contains'},
                    display: false
                },

                status: {
                    name: 'status', label: 'Hiển thị sử dụng', type: "Selection", dataType: 'Label', class: 'center disabled-opacity', width: 12, disabled: true,
                    options: [{ value: 1, label: 'Có'}, { value: 0, label: 'Không'}],
                    filter: { type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals' },
                },
                fied_detail: {
                    refs: ' creator_organization_id ',
                    display: false
                },
            },)
    }

}